module.exports = __webpack_public_path__ + "static/mutant_gif_full-7e664d61cdb87ee8ecf3e25132fd2494.gif";